module.exports = __webpack_public_path__ + "media/internal hemorrhoid.dd60be45.wav";